import React from 'react';
import QRCode from 'qrcode.react';


const QRCodes = () => {
  const appStoreUrl = 'https://apps.apple.com/us/app/opengrit/id6472954854';
  const xtrkUrl = 'https://apps.apple.com/us/app/xtrk/id6569217043';

  return (
    <div className="container">
      <div className="qr-container">
        <h2>OpenGrit App</h2>
        <QRCode
          value={appStoreUrl}
          size={200} // Adjust the size as needed
        />
      </div>
      <div className="qr-container">
        <h2>xTrk App</h2>
        <QRCode
          value={xtrkUrl}
          size={200} // Adjust the size as needed
        />
      </div>
    </div>
  );
};

export default QRCodes;
